export const maxImpactPercents = {
  // Sustainability & Green Engineering
  sustainabilityPressure: 0.008,
  esgCompliance: 0.009,
  greenProductInnovation: 0.009,
  supplyChainCircularity: 0.005,

  // Supply Chain & Supplier Collaboration
  supplierDependency: 0.008,
  collaborationNeed: 0.010,
  geographicSpread: 0.007,
  supplierToolsGap: 0.006,
  supplierSlaPressure: 0.005,
  partnerEcosystemMaturity: 0.007,

  // Strategic Value & Business Model Impact
  serviceRevenue: 0.015,
  businessModelShift: 0.012,
  lifecycleMonetization: 0.010,
  digitalThreadMonetization: 0.012,
  ipPortfolioLeverage: 0.009,
  programMarginUplift: 0.015,
  ipCapitalizationReadiness: 0.008,

  // Risk, Security & Resilience
  mAndAFrequency: 0.006,
  localizationDemand: 0.006,
  technicalDebt: 0.009,
  engineeringIpRisk: 0.010,
  migrationComplexity: 0.006,
  cybersecurityExposure: 0.008,
  resilienceRequirement: 0.009,
  revenueResilience: 0.010,

  // Product & Engineering Complexity
  productComplexity: 0.010,
  changeFrequency: 0.012,
  volumeVarietyMix: 0.008,
  cadIntensity: 0.007,
  lifecycleLength: 0.006,
  reusePotential: 0.009,
  partCount: 0.005,
  productConfigurability: 0.010,
  portfolioBreadth: 0.007,
  programDuration: 0.006,
  crossDomainNeed: 0.009,
  sensorizationLevel: 0.008,
  productAsPlatform: 0.009,

  // Process Maturity & Efficiency
  legacyProcessGap: 0.008,
  digitalMaturity: 0.010,
  infraReadiness: 0.007,
  toolFragmentation: 0.006,
  manualExceptions: 0.007,
  systemAutomation: 0.010,
  exceptionVolume: 0.007,
  testInfrastructure: 0.006,
  legacyCustomizationDebt: 0.006,
  digitalThreadContinuity: 0.010,

  // People, Talent & Culture
  skillDiversity: 0.004,
  userBuyIn: 0.005,
  changeResistance: 0.006,
  plmTalentAvailability: 0.005,

  // Integration & Interoperability
  integrationDepth: 0.012,
  cloudOpsDiscipline: 0.006,
  eventDrivenIntegration: 0.008,
  digitalTwinConvergence: 0.010,
  dataLatencyTolerance: 0.005,
  ecosystemLicensingStrategy: 0.004,
  crossPlmInteroperability: 0.006,
  platformEcosystemParticipation: 0.006,

  // Customer Centricity & Market Fit
  speedSensitivity: 0.011,
  competitivePressure: 0.010,
  innovationThroughput: 0.012,
  customerFeedbackLoop: 0.010,
  timeToValueAcceleration: 0.011,
  customerCoCreationCapability: 0.009,

  // Compliance, Traceability & Governance
  regulatoryBurden: 0.009,
  recallRisk: 0.008,
  traceabilityNeed: 0.010,
  compliancePenalty: 0.008,
  namingDiscipline: 0.004,
  dataGovernanceQuality: 0.006,
  endToEndTraceability: 0.009,
  dataProvenance: 0.005,
  regulatoryAuditReadiness: 0.008,

  // Change & Configuration Impact
  errorCost: 0.015,
  delayPenalty: 0.012,
  engineeringCost: 0.010,
  reuseLibrary: 0.009,
  ipRisk: 0.010,
  aftermarketFocus: 0.007,

  // AI, Analytics & Automation Readiness
  aiReadiness: 0.010,
  analyticsCapability: 0.009,
  aiCoDesignAdoption: 0.010,
  intelligentWorkflowOrchestration: 0.011
};
